import ApiService from "./api.service";

const CidadeService = {
  async getCidades(params) {
    return await ApiService.get("/cidades", params);
  },
};

export default CidadeService;
